import axios from "axios";
import { getToken, clearSession } from "./session";
import { resolveApiBase } from "./apiBase";

axios.defaults.baseURL = resolveApiBase();

/** IRANSans cannot draw Pashto ځ; normalize faculty spelling to پوهنحی. */
function rewriteFacultySpelling(value) {
  if (typeof value === "string") {
    return value.split("پوهنځی").join("پوهنحی").split("پوهنهی").join("پوهنحی");
  }
  if (Array.isArray(value)) {
    return value.map(rewriteFacultySpelling);
  }
  if (value && typeof value === "object") {
    const out = Array.isArray(value) ? [] : {};
    Object.keys(value).forEach((key) => {
      out[key] = rewriteFacultySpelling(value[key]);
    });
    return out;
  }
  return value;
}

axios.interceptors.request.use(
  async (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (result) => {
    if (result && result.data != null) {
      result.data = rewriteFacultySpelling(result.data);
    }
    return result;
  },
  (error) => {
    const status = error?.response?.status;
    const url = String(error?.config?.url || "");
    // Force re-login on auth failures for session bootstrap / protected reads.
    const isSessionProbe =
      url.indexOf("/login") !== -1 ||
      url.indexOf("dropdowns/") !== -1 ||
      url.indexOf("calendar/") !== -1 ||
      url.indexOf("mis/") !== -1;

    if (status === 401 && isSessionProbe) {
      clearSession();
      if (window.location.pathname.indexOf("/login") === -1) {
        window.location.replace("/login.html");
      }
    }
    return Promise.reject(error);
  }
);

export default {
  delete: axios.delete,
  patch: axios.patch,
  post: axios.post,
  get: axios.get,
  put: axios.put,
};
